<!-- eslint-disable vue/max-len -->
<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      :class="`svg-subtract color-fill-${color}`"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2858 1.98315C9.91578 2.06724 9.54433 2.17838 9.17143 2.31657C8.21905 2.66951 7.3619 3.19893 6.6 3.90481C5.8381 4.61069 5.21429 5.48814 4.72857 6.53716C4.24286 7.58618 4 8.80677 4 10.1989C4 12.0421 4.6619 13.9244 5.98571 15.846C7.30952 17.7676 9.31429 19.7479 12 21.7872C14.6857 19.7479 16.6905 17.7676 18.0143 15.846C18.935 14.5096 19.5355 13.1921 19.8159 11.8936H17.447C17.2112 12.6628 16.8193 13.4607 16.2714 14.2872C15.3095 15.7381 13.8857 17.2479 12 18.8166C10.1143 17.2479 8.69048 15.7381 7.72857 14.2872C6.76667 12.8362 6.28571 11.4734 6.28571 10.1989C6.28571 9.10089 6.48095 8.16461 6.87143 7.3901C7.2619 6.61559 7.74286 5.98814 8.31429 5.50775C8.88571 5.02736 9.50476 4.67932 10.1714 4.46363C10.2097 4.45124 10.2478 4.4392 10.2858 4.42753V1.98315Z"
    />
    <path
      :class="`svg-arrow color-stroke-${color}`"
      d="M19 7L15 7L15 3"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="square"
    />
    <circle :class="`svg-circle color-fill-${color}`" cx="12" cy="10" r="2" />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
}

withDefaults(defineProps<icon>(), {
  color: 'black',
});
</script>
